<template>
  <h1 id="check-email-message">Please check your email for a validation link</h1>
</template>

<script>
export default {
  name: 'CheckEmail',
}
</script>

<style>
#check-email-message {
  position: absolute;
  top: 40vh;
  width: 100vw;
  color: darkgrey;
  font-size: 150%;
  text-align: center;
  line-height: 2em;
}
</style>
